import { render, staticRenderFns } from "./UserShare.vue?vue&type=template&id=2e180eb7&scoped=true&"
import script from "./UserShare.vue?vue&type=script&lang=js&"
export * from "./UserShare.vue?vue&type=script&lang=js&"
import style0 from "./UserShare.vue?vue&type=style&index=0&id=2e180eb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e180eb7",
  null
  
)

export default component.exports